import './core.js';

$(document).ready(function() {
	$('#announcement-modal').modal('show');
});
